export default __webpack_public_path__ + "static/respuesta-f7657daa7965a79b0f9c4ec1b8996e4d.jpg";